import type { RootState } from "@/app/store";
import { ProgramacaoColetaAnalise } from "@/contexts/laboratorio/programacaoColeta/model/ProgramacaoColetaAnalise";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProgramacaoState {
  items: ProgramacaoColetaAnalise[];
  synced: boolean;
}

const initialState: ProgramacaoState = {
  items: [],
  synced: false,
};

const programacaoColetaAnaliseSlice = createSlice({
  name: "PROGRAMACAO_COLETA_ANALISE",
  initialState,
  reducers: {
    sync: {
      reducer: (
        state,
        action: PayloadAction<{ items: ProgramacaoColetaAnalise[] }>
      ) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: ProgramacaoColetaAnalise[]) => ({
        payload: { items },
      }),
    },
  },
});

export const programacaoAction = programacaoColetaAnaliseSlice.actions;

export default programacaoColetaAnaliseSlice.reducer;

export const getProgramacaoSynced = (state: RootState) =>
  state.programacaoColetaAnalise.items;
